<template>
    <SquareButton @click="replay">
        <Icon type="md-refresh" />
    </SquareButton>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import SquareButton from "@/components/common/SquareButton.vue";

import bus from "@/bus";

import { PlaybackBannerActions } from "@/components/PlaybackControls/usePlaybackController";
import { useGA4Tracking } from "@/composables/useGA4Tracking";
import GA4 from "@/enums/ga4Events";

export default defineComponent({
    components: {
        SquareButton
    },

    props: {
        id: {
            type: String,
            required: true
        },

        playbackNamespace: {
            type: String,
            required: true
        }
    },

    setup() {
        const ga4 = useGA4Tracking();

        return {
            ga4
        };
    },

    methods: {
        replay() {
            this.ga4.trackSegmentInteraction({
                segmentId: this.id,
                segmentName: GA4.SEGMENT_NAMES.REPLAY_BANNER,
                interactionType: GA4.SEGMENT_INTERACTIONS.CLICK,
                segmentCategory: GA4.SEGMENT_CATEGORIES.PLAYBACK_CONTROLS
            });
            bus.$emit(PlaybackBannerActions.ReplayBanner, { namespace: this.playbackNamespace, id: this.id });
        }
    }
});
</script>
